import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'homepage-information',
  templateUrl: 'homepage-information.html',
  inputs: ['header', 'content']
})
export class HomepageInformationComponent implements AfterViewInit {

  header: any;
  content: any;

  constructor() {

  }

  ngAfterViewInit(): void {

  }

}



// WEBPACK FOOTER //
// ./src/components/homepage-information/homepage-information.ts